import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import Image from "next/image";

import { CustomLink } from "@/components/CustomLink";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.client";
import type { MenuItemType } from "@/types/baseTypes";
import { downloadFile } from "@/utils/downloadFile";

import styles from "./CulinaryCard.module.scss";

interface CulinaryCardProps {
  item: MenuItemType;
  onNavigate: () => void;
}

export const CulinaryCard = ({ item, onNavigate }: CulinaryCardProps) => {
  const { getIcon } = useGlobalContext();

  const icon = item.acf?.icon || undefined;
  const download = item.acf?.download || undefined;
  const file = download?.download_file || undefined;

  const handleDownload = () => {
    if (!file?.url) return;

    downloadFile(file.url, file.filename).catch((e) => {
      console.error("Download failed:", e);
    });
    onNavigate();
  };

  return (
    <div className={styles["culinary-card"]}>
      <CustomLink
        className={styles["culinary-card-media"]}
        href={item.url}
        target={item.target || "_self"}
        aria-label={item.title}
        onClick={onNavigate}
        disablePrefetch
      >
        {icon?.url && (
          <div className={styles["culinary-card-logo"]}>
            <Image src={icon.url} alt={icon.alt || item.title} fill />
          </div>
        )}
      </CustomLink>
      {file?.url && (
        <button
          type="button"
          className={styles["culinary-card-download"]}
          aria-label={download?.aria_label || download?.label}
          onClick={handleDownload}
        >
          <CustomSVG
            width={16}
            height={16}
            src={getIcon("arrow_down")}
            wrapper="span"
            aria-hidden="true"
          />
          <span>{download?.label}</span>
        </button>
      )}
    </div>
  );
};
